export type AppMode = 'standalone' | 'unity'

export const APP_MODES: Record<string, AppMode> = {
  STANDALONE: 'standalone',
  UNITY: 'unity',
}
